import React, { useState, useEffect, useRef, useMemo } from "react";
import { FaSearch, FaTimes, FaArrowDown, FaArrowUp } from "react-icons/fa";
import {
  fetchArticleByUserId,
  fetchVolIss,
  updateArticle,
} from "../../services/apiService/articleApi";
import {
  fetchIssueById,
  fetchIssueByUserId,
  updateIssue,
} from "../../services/apiService/issueApi";
import { fetchJournals } from "../../services/apiService/journalApi";
import { useSelector } from "react-redux";
import { CustomTable } from "../../components/Table";
import useToaster from "../../hooks/useToaster";
import SortDropdown from "../../components/ui/DropdownSort";
import DropdownCheckbox from "../../components/ui/DropdownCheck";
import { Popover, PopoverTrigger } from "../../components/ui/Popover";
import bookpng from "../../assets/article.png";
import { useNavigate } from "react-router-dom";
import { PageSkeletons, Spinner } from "../../components/ui/Skeleton";
import Pagination from "../../components/ui/Pagination";
import FilterChips from "../../components/ui/FilterChip";
import {
  MdOutlineFilterAlt,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";
import DynamicFilterPopover from "../../components/ui/DynamicFilterPopover";
import IssueDetails from "../../components/forms/NewIssueForm";
import ArticleForm from "../../components/forms/JournalOverviewForm";
import { fetchUserForForm } from "../../services/apiService/userApi";
import DataSyncError from "../../components/edgeCases/DataSyncError";

const MyHistoryTable = ({ journalName = "", active, setIsReload }) => {
  const [isFocused, setIsFocused] = useState(false);
  const [lastSync, setLastSync] = useState(new Date());
  const [showSortOptions, setShowSortOptions] = useState(false);
  const [showVolIssOptions, setShowVolIssOptions] = useState(false);
  const [showJournalOptions, setShowJournalOptions] = useState(false);
  const [showFilterPopover, setShowFilterPopover] = useState(false);
  const [activeTab, setActiveTab] = useState("Article");
  const [articles, setArticles] = useState([]);
  const [issues, setIssues] = useState([]);
  const [articleCount, setArticleCount] = useState(0);
  const [issueCount, setIssueCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(100);
  const [issueCursor, setIssueCursor] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  });
  const [tempSortKey, setTempSortKey] = useState(null);
  const [tempSortDirection, setTempSortDirection] =
    useState("Sort by Ascending");
  const [loadingState, setLoadingState] = useState("spinning");
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);
  const [activeRowId, setActiveRowId] = useState(null);
  const [hasFilters, setHasFilters] = useState(false);
  const [isLoadingArticles, setIsLoadingArticles] = useState(false);
  const [isLoadingIssues, setIsLoadingIssues] = useState(false);

  let [articleTypesOptions, setArticleTypesOptions] = useState([]);
  let [productionWorkflowOptions, setProductionWorkflowOptions] = useState([]);

  let [JournalOptions, setJournalOptions] = useState([]);
  let [IssueJournalOptions, setIssueJournalOptions] = useState([]);

  let [volIssOptions, setVolIssOptions] = useState([]);
  let [IssueVolIssOptions, setIssueVolIssOptions] = useState([]);
  const [articleTypeOpen, setArticleTypeOpen] = useState(false);
  const [productionWorkflowOpen, setProductionWorkflowOpen] = useState(false);

  const [articleFilters, setArticleFilters] = useState({
    searchQuery: "",
    selectedVolIss: ["All"],
    selectedJournals: ["All"],
    articleTypes: ["All"],
    copyediting: ["All"],
    tempArticleTypes: ["All"],
    tempSelectedJournals: ["All"],
    tempCopyediting: ["All"],
    selectedJournalId: [],
  });

  const [issueFilters, setIssueFilters] = useState({
    searchQuery: "",
    selectedVolIss: ["All"],
    selectedJournals: ["All"],
    tempSelectedJournals: ["All"],
    task: [],
    tempTask: [],
    selectedJournalId: [],
  });

  const searchTriggeredRef = useRef(false);
  const sortEffectRanRef = useRef(false);

  const { userData, preferences, dataSyncTime } = useSelector(
    (state) => state.user
  );

  let [openForm, setOpenForm] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedFieldConfig, setSelectedFieldConfiguration] = useState([]);
  const [userOption, setUserOption] = useState([]);
  const [objectUserOption, setObjectUserOption] = useState([]);

  const userId = userData?.id;
  const showToast = useToaster();
  const navigate = useNavigate();

  const headers = {
    Article: [
      { key: "journalInfo?.journalName", value: "JOURNAL" },
      {
        key: "pts",
        value: "PTS#",
        onClick: onRowSelect,
        style: { cursor: "pointer" },
      },
      { key: "volume", value: "VOLUME" },
      { key: "issue", value: "ISSUE" },
      { key: "em", value: "EM#" },
      { key: "pit", value: "PIT" },
      { key: "docHead", value: "DOCHEAD" },
      {
        key: "productionWorkflow",
        value: "PROD WF",
      },
      { key: "firstAuthor", value: "FIRST AU" },
      {
        key: "correspondingAuthor",
        value: "CORR AU",
      },
      { key: "speedTarget", value: "SPEED TARGET" },
      { key: "onDate", value: "ON DATE" },
      { key: "itemHoldout", value: "HOLDOUT" },
      { key: "itemFinalizing", value: "FINALIZING" },
      {
        key: "copyEditTaskComplete",
        value: "CE CLOSED",
      },
      {
        key: "auProofCorrectionsSubmitted",
        value: "AU CX REC",
      },
      {
        key: "revisedProofRequested",
        value: "RPR",
      },
      { key: "cfcTaskComplete", value: "CFC CLOSED" },
      {
        key: "revisedProofApproved",
        value: "REV OK",
      },
      {
        key: "productionNotes",
        value: "POST-ACC NOTES",
      },
      { key: "journalInfo?.team", value: "TEAM" },
    ],
    Issue: [
      { key: "journal", value: "JOURNAL" },
      {
        key: "volIss",
        value: "VOL/ISS",
        onClick: onRowSelect,
        style: { cursor: "pointer" },
      },
      { key: "task", value: "TASK" },
      { key: "team", value: "TEAM" },
      { key: "taskDueDate", value: "DUE DATE" },
    ],
  };

  const hasChangesArray = [
    "issue",
    "volume",
    // "productionWorkflow",
    // "handlingEditor",
    // "dateBackFromSce",
    // "sceReturnedStatus",
  ];

  useEffect(() => {
    if (activeTab === "Article") {
      setSortConfig({ key: null, direction: "asc" });
    } else {
      setSortConfig({
        key: null,
        direction: "asc",
      });
    }
  }, [activeTab]);

  const fetchDataOnSearch = () => {
    if (!searchTriggeredRef.current) return;
    if (
      (articleFilters.searchQuery.trim().length > 2 ||
        !articleFilters.searchQuery.length) &&
      activeTab === "Article"
    ) {
      fetchArticlesData();
    } else if (
      (issueFilters.searchQuery.trim().length > 2 ||
        !issueFilters.searchQuery.length) &&
      activeTab === "Issue"
    ) {
      fetchIssuesData();
    }
  };

  async function onRowSelect(task) {
    setOpenForm(true);
    try {
      let newTask = task;
      if (activeTab === "Issue") {
        const issue = await fetchIssueById(task.id);
        if (issue.success && issue?.data) {
          newTask = issue?.data;
          setSelectedFieldConfiguration(
            newTask?.ArticleDetails?.[0]?.journalInfo?.fieldConfiguration
          );
        }
      } else {
        setSelectedFieldConfiguration(task?.journalInfo?.fieldConfiguration);
      }
      setSelectedTask(newTask);
      await fetchUsersList();
    } catch (error) {
      showToast(error.message ?? "Something went wrong");
    }
  }

  const handleUpdateTask = async (updatedTask) => {
    try {
      let updateFunction =
        activeTab === "Article" ? updateArticle : updateIssue;

      const response = await updateFunction(updatedTask.id, updatedTask);

      if (response.success) {
        showToast("Task updated successfully");
        handleCloseForm();
      } else {
        showToast(response.message || "Failed to update task");
      }
    } catch (error) {
      console.error("Error updating task:", error);
      showToast("Error updating task: " + error.message);
    } finally {
      if (activeTab === "Article") {
        await fetchArticlesData();
      } else {
        await fetchIssuesData();
      }
    }
  };

  const handleCloseForm = () => {
    setSelectedTask(null);
    setOpenForm(false);
    setActiveRowId(null);
  };

  const fetchUsersList = async () => {
    const response = await fetchUserForForm();
    if (response.success) {
      const { userNames, userOptions } = response?.data;
      setUserOption(userNames);
      setObjectUserOption(userOptions);
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchDataOnSearch();
    }, 600);

    return () => clearTimeout(timeoutId);
  }, [articleFilters.searchQuery, issueFilters.searchQuery]);

  const fetchArticlesData = async () => {
    try {
      setIsLoadingArticles(true);
      const response = await fetchArticleByUserId(userId, {
        limit: itemsPerPage,
        page: currentPage,
        time: "past",
        journal: articleFilters.selectedJournalId,
        docHead: articleFilters.articleTypes,
        search: articleFilters.searchQuery.trim(),
        copyedit: articleFilters.copyediting,
        volIss: articleFilters.selectedVolIss,
        key: sortConfig.key,
        direction: sortConfig.direction,
      });
      fetchVolIssOptions();

      if (!response.success) {
        showToast("Failed to load articles");
        setArticles([]);
        setArticleCount(0);
        setTotalItems(0);
        setTotalPages(1);
        setIssueCount(0);
        return;
      }

      if (response.success && response?.data?.data.length < 1) {
        setArticles([]);
        setArticleCount(0);
        setIssueCount(response?.data?.issuesCount);
        setTotalItems(0);
        setTotalPages(1);
        return;
      }

      const { pagination, data, issuesCount } = response.data;

      const mapped = data.map((article) => {
        return {
          ...article,
          hasChanges:
            Array.isArray(article.changes) &&
            article.changes.some(
              (change) =>
                change.key &&
                change.previousValue !== null &&
                hasChangesArray.includes(change.key)
            ),
          type: "Article",
          journal: article.journalInfo?.journalName,
        };
      });

      setArticles(mapped);
      setIssueCount(issuesCount);
      setArticleCount(pagination.totalItems);
      setTotalItems(pagination.totalItems);
      setTotalPages(pagination.totalPages);
    } catch (err) {
      showToast("Failed to load articles");
      setArticles([]);
      setArticleCount(0);
      setTotalItems(0);
      setTotalPages(1);
      setIssueCount(0);
      return;
    } finally {
      setIsLoadingArticles(false);
    }
  };

  const fetchIssuesData = async () => {
    try {
      setIsLoadingIssues(true);
      const response = await fetchIssueByUserId(userId, {
        limit: itemsPerPage,
        page: currentPage,
        time: "past",
        journal: issueFilters.selectedJournalId,
        task: issueFilters.task,
        search: issueFilters.searchQuery.trim(),
        volIss: issueFilters.selectedVolIss,
        key: sortConfig.key,
        direction: sortConfig.direction,
      });
      fetchVolIssOptions();

      if (!response.success) {
        showToast("Failed to load Issues");
        setIssues([]);
        setIssueCount(0);
        setTotalItems(0);
        setTotalPages(1);
        setIssueCursor(null);
        return;
      }

      if (response.success && response?.data?.data.length < 1) {
        setIssues([]);
        setIssueCount(0);
        setTotalItems(0);
        setTotalPages(1);
        return;
      }

      const { pagination, data, nextCursor } = response.data;

      setIssues(data);
      setIssueCount(pagination.totalItems);
      setTotalItems(pagination.totalItems);
      setTotalPages(pagination.totalPages);
      setIssueCursor(nextCursor);
    } catch (err) {
      setIssues([]);
      setIssueCount(0);
      setTotalItems(0);
      setTotalPages(1);
    } finally {
      setIsLoadingIssues(false);
    }
  };

  const loadAllData = async () => {
    let success = false;
    const startTime = Date.now();

    if (!hasLoadedOnce) {
      setLoadingState("spinning");
    }

    setIsLoading(true);

    try {
      await Promise.all([fetchArticlesData()]);
      sortEffectRanRef.current = true;
      success = true;
    } catch (err) {
      // Error handled in individual fetch functions
    } finally {
      setIsLoading(false);

      if (!hasLoadedOnce) {
        const timeTaken = Date.now() - startTime;

        if (timeTaken < 2000) {
          setLoadingState("data");
          setHasLoadedOnce(true);
        } else if (timeTaken < 5000) {
          setTimeout(() => {
            setLoadingState("data");
            setHasLoadedOnce(true);
          }, 2000);
        } else {
          setTimeout(() => {
            setLoadingState("skeleton");
            setTimeout(() => {
              setLoadingState("data");
            }, 2000);
          }, 3000);
        }
      }
    }
  };

  useEffect(() => {
    loadAllData();
  }, []);

  useEffect(() => {
    if (!sortEffectRanRef.current) return;
    if (activeTab === "Article") {
      fetchArticlesData();
    } else {
      fetchIssuesData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentPage,
    itemsPerPage,
    articleFilters.selectedJournalId,
    articleFilters.articleTypes,
    articleFilters.copyediting,
    articleFilters.selectedVolIss,
    issueFilters.selectedJournalId,
    issueFilters.task,
    issueFilters.selectedVolIss,
    sortConfig,
    preferences,
  ]);

  useEffect(() => {
    if (!sortEffectRanRef.current) return;
    setIssueCursor(null);
  }, [
    issueFilters.searchQuery,
    issueFilters.selectedJournalId,
    issueFilters.task,
    issueFilters.selectedVolIss,
    issueFilters.selectedJournals,
  ]);

  const isInitialLoading = useMemo(() => {
    if (activeTab === "Article") {
      return articles.length === 0 && isLoadingArticles;
    }
    return issues.length === 0 && isLoadingIssues;
  }, [articles, isLoadingArticles, issues, isLoadingIssues, activeTab]);

  let fetchVolIssOptions = async () => {
    try {
      let response = await fetchVolIss({
        id: userData.id,
        type: activeTab === "Article" ? "Article" : "Issue",
        time: "past",
        journal: "",
        place: "myTaskHistory",
      });
      if (activeTab === "Article") {
        setVolIssOptions(response.data.data.volIss);
        setProductionWorkflowOptions(response?.data?.data?.productionWorkflow);
        setArticleTypesOptions(response?.data?.data?.docHead);
        setJournalOptions(response?.data?.data?.journalId);
      } else {
        setIssueJournalOptions(response?.data?.data?.journalId);
        setIssueVolIssOptions(response.data.data.volIss);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchVolIssOptions();
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === "Article") {
      setArticleFilters((prev) => ({
        ...prev,
        searchQuery: "",
      }));
    } else {
      setIssueFilters((prev) => ({
        ...prev,
        searchQuery: "",
      }));
    }
  }, [activeTab]);

  const getFilterLabel = (selectedItems, defaultLabel, options = []) => {
    if (selectedItems?.includes("All") || selectedItems?.length === 0) {
      return `${defaultLabel}: All`;
    }
    const selectedLabels = selectedItems?.map((item) => {
      const option = options?.find((opt) => opt?.value === item);
      return option?.label ?? item;
    });
    return selectedLabels?.length === 1
      ? `${defaultLabel}: ${selectedLabels?.[0]}`
      : `${defaultLabel}: ${selectedLabels?.[0]} + more`;
  };

  const handlePageChange = (page) => {
    if (activeTab === "Article" && page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    } else if (activeTab === "Issue") {
      if (page > currentPage) {
        setCurrentPage(page);
      } else if (page === 1) {
        setIssueCursor(null);
        setCurrentPage(1);
      }
    }
  };

  const handleVolIssSelection = (selected) => {
    const newSelection =
      selected.includes("All") || selected.length === 0 ? ["All"] : selected;
    if (activeTab === "Article") {
      setArticleFilters((prev) => ({ ...prev, selectedVolIss: newSelection }));
    } else {
      setIssueFilters((prev) => ({ ...prev, selectedVolIss: newSelection }));
    }
    setCurrentPage(1);
  };

  const handleJournalSelection = (selected, journals) => {
    let journalOption =
      activeTab === "Article" ? JournalOptions : IssueJournalOptions;
    const newSelection =
      selected.includes("All") ||
      selected.length === 0 ||
      journalOption.length === selected.length
        ? ["All"]
        : selected;
    const newJournalIds =
      selected.includes("All") ||
      selected.length === 0 ||
      journalOption.length === selected.length
        ? []
        : journals;

    const isAllSelected =
      (Array.isArray(newSelection) &&
        newSelection.length === 1 &&
        newSelection[0] === "All") ||
      journalOption.length === selected.length;

    if (activeTab === "Article") {
      setArticleFilters((prev) => ({
        ...prev,
        selectedJournals: newSelection,
        // tempSelectedJournals: newSelection,
        tempSelectedJournals: isAllSelected
          ? newSelection
          : newJournalIds?.map((data) => data.value),
        selectedJournalId: newJournalIds,
      }));
    } else {
      setIssueFilters((prev) => ({
        ...prev,
        selectedJournals: newSelection,
        // tempSelectedJournals: newSelection,
        tempSelectedJournals: isAllSelected
          ? newSelection
          : newJournalIds?.map((data) => data.value),
        selectedJournalId: newJournalIds,
      }));
    }
    setCurrentPage(1);
  };

  const handleClearFilters = () => {
    if (activeTab === "Article") {
      setArticleFilters({
        selectedVolIss: ["All"],
        selectedJournals: ["All"],
        articleTypes: ["All"],
        copyediting: ["All"],
        searchQuery: "",
        tempArticleTypes: ["All"],
        tempCopyediting: ["All"],
        selectedJournalId: [],
        tempSelectedJournals: ["All"],
      });
    } else {
      setIssueFilters({
        selectedVolIss: ["All"],
        selectedJournals: ["All"],
        task: [],
        tempTask: [],
        searchQuery: "",
        selectedJournalId: [],
        tempSelectedJournals: ["All"],
      });
    }
    setCurrentPage(1);
    setHasFilters(false);
    setIssueCursor(null);
  };

  const handleTempArticleTypeChange = (type) => {
    setArticleFilters((prev) => ({
      ...prev,
      tempArticleTypes: type.length >= 1 ? type : ["All"],
    }));
  };

  const handleTempCopyeditingChange = (copyeditingOption) => {
    setArticleFilters((prev) => ({
      ...prev,
      tempCopyediting:
        copyeditingOption.length >= 1 ? copyeditingOption : ["All"],
    }));
  };

  const handleTempTaskChange = (task) => {
    setIssueFilters((prev) => ({
      ...prev,
      tempTask: task,
      //   prev.tempTask.includes(task)
      //     ? prev.tempTask.filter((c) => c !== task)
      //     : [...prev.tempTask, task],
    }));
  };

  const applyFilters = () => {
    if (activeTab === "Article") {
      setArticleFilters((prev) => ({
        ...prev,
        articleTypes: [...prev.tempArticleTypes],
        copyediting: [...prev.tempCopyediting],
      }));
    } else {
      setIssueFilters((prev) => ({
        ...prev,
        task: [...prev.tempTask],
      }));
    }
    setCurrentPage(1);
    setShowFilterPopover(false);
    setHasFilters(true);
    if (activeTab === "Issue") setIssueCursor(null);
  };

  useEffect(() => {
    const filters = activeTab === "Article" ? articleFilters : issueFilters;
    if (
      (activeTab === "Article" &&
        ((articleFilters.copyediting.length > 0 &&
          !articleFilters.copyediting.includes("All")) ||
          (articleFilters.articleTypes.length > 0 &&
            !articleFilters.articleTypes.includes("All")))) ||
      (activeTab === "Issue" && filters.task.length > 0)
    ) {
      setHasFilters(true);
    } else {
      setHasFilters(false);
    }
  }, [activeTab, articleFilters, issueFilters]);

  const handleSearchChange = (e) => {
    searchTriggeredRef.current = true;
    const value = e.target.value;
    if (activeTab === "Article") {
      setArticleFilters((prev) => ({ ...prev, searchQuery: value }));
    } else {
      setIssueFilters((prev) => ({ ...prev, searchQuery: value }));
    }
  };

  const HandleClearSearch = () => {
    if (activeTab === "Article") {
      setArticleFilters((prev) => ({ ...prev, searchQuery: "" }));
      setIsLoadingArticles(true);
    } else {
      setIssueFilters((prev) => ({ ...prev, searchQuery: "" }));
      setIsLoadingIssues(true);
    }
  };

  const handleAdvancedClearFilter = () => {
    if (activeTab === "Article") {
      setArticleFilters((prev) => ({
        ...prev,
        tempArticleTypes: ["All"],
        tempCopyediting: ["All"],
      }));
      setCurrentPage(1);
    } else {
      setIssueFilters((prev) => ({
        ...prev,
        tempTask: [],
      }));
      setCurrentPage(1);
    }
    setHasFilters(false);
    setIssueCursor(null);
  };

  const ArticleSections = [
    {
      label: "Dochead",
      key: "articleType",
      values: articleTypesOptions,
    },
    {
      label: "Production workflow",
      key: "productionWorkflow",
      values: productionWorkflowOptions,
    },
  ];

  const ArticleTempValues = {
    articleType: articleFilters.tempArticleTypes,
    productionWorkflow: articleFilters.tempCopyediting,
  };

  const ArticleTempSetValues = {
    articleType: handleTempArticleTypeChange,
    productionWorkflow: handleTempCopyeditingChange,
  };

  const IssueSection = [
    {
      label: "Task",
      key: "task",
      values: [
        { value: "coverHandler", label: "Cover handling" },
        { value: "tocHandler", label: "TOC handling" },
        { value: "webHandler", label: "Web handling" },
        { value: "finalizingHandler", label: "Finalizing handling" },
      ],
    },
  ];

  const IssueTempValues = {
    task: issueFilters.tempTask,
  };

  const IssueSetTempValues = {
    task: handleTempTaskChange,
  };

  const sections = activeTab === "Article" ? ArticleSections : IssueSection;
  const tempSelected =
    activeTab === "Article" ? ArticleTempValues : IssueTempValues;
  const setTempSelected =
    activeTab === "Article" ? ArticleTempSetValues : IssueSetTempValues;

  const isNoTasks =
    activeTab === "Article" ? articleCount === 0 : issueCount === 0;
  const currentFilters =
    activeTab === "Article" ? articleFilters : issueFilters;

  const isSearchEmpty = useMemo(() => {
    return activeTab === "Article"
      ? articleFilters.searchQuery.trim().length < 1
      : issueFilters.searchQuery.trim().length < 1;
  }, [articleFilters, issueFilters, activeTab]);

  return loadingState === "spinning" ? (
    <div className="flex items-center justify-center h-full">
      <Spinner />
    </div>
  ) : loadingState === "skeleton" ? (
    <PageSkeletons />
  ) : (
    <div
      className="bg-gray-100 flex flex-col"
      style={{
        fontFamily: "Source Sans Pro, sans-serif",
        height: "calc(100vh - 72px)",
      }}
    >
      <div className="flex-1 p-6 bg-white flex flex-col h-full">
        {!openForm && (
          <>
            <>
              <div className="header-section shrink-0 bg-white sticky top-0 z-10">
                <div className="flex items-center justify-start mb-3 space-x-1">
                  <p className="text-[#868E94] font-medium text-[13px]">
                    My Tasks History
                  </p>{" "}
                  <MdOutlineKeyboardArrowRight className="text-[#5D6871] text-[16px]" />{" "}
                  <p className="text-[#5D6871] font-medium text-[13px]">
                    {activeTab}
                  </p>
                </div>
                <div className="flex items-center justify-between mb-2">
                  <h1 className="text-[#20282E] text-[23px] h-[32px] font-semibold">
                    My Tasks History
                  </h1>
                  <span className="text-[11px] h-[14px] w-[165px] text-[#35424D] font-medium flex items-center">
                    <DataSyncError />
                    Last Sync: {dataSyncTime?.value}
                    <br></br>
                    {/* {dataSyncTime?.value ? "Snowflake data not available." : ""} */}
                  </span>
                </div>
                <div className="flex items-center justify-between border-b-2 border-gray-200 mb-3">
                  <div className="flex">
                    <button
                      className={`p-3 flex items-center h-[28px] ${
                        activeTab === "Article"
                          ? "border-b-2 border-[#1C40C9] text-[13px] text-[#35424D] font-semibold"
                          : "font-medium hover:text-[#35424D] text-[13px]"
                      }`}
                      onClick={() => {
                        setActiveTab("Article");
                        setCurrentPage(1);
                      }}
                    >
                      Article ({articleCount})
                    </button>
                    <button
                      className={`p-3 flex items-center h-[28px] ${
                        activeTab === "Issue"
                          ? "border-b-2 border-[#1C40C9] text-[13px] text-[#35424D] font-semibold"
                          : "font-medium hover:text-[#35424D] text-[13px]"
                      }`}
                      onClick={() => {
                        setActiveTab("Issue");
                        setCurrentPage(1);
                      }}
                    >
                      Issue ({issueCount})
                    </button>
                  </div>
                </div>
                <div className="flex items-center justify-between mb-4">
                  <div className="relative w-[246px]">
                    <input
                      type="text"
                      className={`border rounded-[4px] w-[246px] h-[32px] py-[4px] px-[12px] pr-[32px] text-sm transition-colors ${
                        isFocused
                          ? " focus:border-[#35424D] focus:border focus:outline-none"
                          : "border-[#C3C3C3]"
                      } `}
                      placeholder="Search"
                      maxLength={100}
                      value={currentFilters.searchQuery}
                      onChange={handleSearchChange}
                      onFocus={() => setIsFocused(true)}
                      onBlur={() =>
                        currentFilters.searchQuery === "" && setIsFocused(false)
                      }
                    />
                    {(!isFocused ||
                      currentFilters.searchQuery.length === 0) && (
                      <FaSearch className="absolute right-3 top-1/2 transform -translate-y-1/2 text-[#C3C3C3]" />
                    )}
                    {currentFilters.searchQuery.length > 0 && (
                      <FaTimes
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-[#C3C3C3] cursor-pointer"
                        onClick={HandleClearSearch}
                      />
                    )}
                  </div>
                  <div className="flex items-center gap-2">
                    <Popover
                      open={showSortOptions}
                      onOpenChange={setShowSortOptions}
                    >
                      <PopoverTrigger asChild>
                        <button
                          className={`flex items-center gap-1 px-3 py-1 h-[32px] rounded-md hover:bg-[#EFF1F1] ${
                            showSortOptions ? "bg-[#D9D9D9]" : ""
                          }`}
                        >
                          <span className="text-[#35424D] font-semibold text-[13px] flex items-center gap-1">
                            Sort by:
                            <span className="flex items-center font-medium gap-1">
                              {sortConfig.direction === "asc" ? (
                                <FaArrowUp className="text-[#35424D] h-[12px]" />
                              ) : sortConfig.direction === "desc" ? (
                                <FaArrowDown className="text-[#35424D] h-[12px]" />
                              ) : null}
                              {(() => {
                                const header =
                                  activeTab === "Article"
                                    ? headers["Article"]
                                    : headers["Issue"];

                                if (!sortConfig.key) return "";

                                const match = header?.find((h) => {
                                  const headerKeyLast = h.key.includes(".")
                                    ? h.key.split(".").pop()
                                    : h.key;
                                  const sortKeyLast = sortConfig.key.includes(
                                    "."
                                  )
                                    ? sortConfig.key.split(".").pop()
                                    : sortConfig.key;
                                  return headerKeyLast === sortKeyLast;
                                });

                                return match?.value || "";
                              })()}
                            </span>
                          </span>
                          <i
                            className={`fas fa-chevron-down text-[#35424D] text-[14px] ${
                              showSortOptions ? "rotate-180" : ""
                            }`}
                          />
                        </button>
                      </PopoverTrigger>
                      <SortDropdown
                        headers={
                          activeTab === "Article"
                            ? headers.Article
                            : headers.Issue
                        }
                        activeTab={activeTab}
                        isOpen={showSortOptions}
                        sortConfig={sortConfig}
                        setSortConfig={setSortConfig}
                        tempSortKey={tempSortKey}
                        setTempSortKey={setTempSortKey}
                        tempSortDirection={tempSortDirection}
                        setTempSortDirection={setTempSortDirection}
                        setShowSortOptions={setShowSortOptions}
                        setClientPagination={() => setCurrentPage(1)}
                      />
                    </Popover>

                    {/* {activeTab === "Issue" && (
                  <Popover
                    open={showVolIssOptions}
                    onOpenChange={(open) => {
                      // for removing temp selected data
                      if (!open) {
                        setVolIssOptions((prev) => [...prev]);
                      }
                      setShowVolIssOptions(open);
                    }}
                  >
                    <PopoverTrigger asChild>
                      <button
                        className={`flex items-center gap-1 px-3 py-1 h-[32px] rounded-md hover:bg-[#EFF1F1] ${
                          showVolIssOptions ? "bg-[#D9D9D9]" : ""
                        }`}
                      >
                        <span className="text-[#35424D] text-[13px]">
                          <span className="font-semibold">Vol/Iss:</span>{" "}
                          <span className="font-medium">
                            {currentFilters.selectedVolIss.includes("All")
                              ? "All"
                              : `${currentFilters.selectedVolIss[0]}${
                                  currentFilters.selectedVolIss.length > 1
                                    ? " + more"
                                    : ""
                                }`}
                          </span>
                        </span>
                        <i
                          className={`fas fa-chevron-down text-xs ${
                            showVolIssOptions ? "rotate-180" : ""
                          }`}
                        />
                      </button>
                    </PopoverTrigger>
                    <DropdownCheckbox
                      options={
                        activeTab === "Article"
                          ? volIssOptions
                          : IssueVolIssOptions
                      }
                      selectedValues={currentFilters.selectedVolIss}
                      onSelectionChange={handleVolIssSelection}
                      selectAllText="All"
                      clearAllText="Clear all"
                      applyText="Apply"
                      searchPlaceholder="Search vol/Iss..."
                      onClose={() => setShowVolIssOptions(false)}
                    />
                  </Popover>
                )} */}
                    <Popover
                      open={showJournalOptions}
                      onOpenChange={(open) => {
                        // for removing temp selected data
                        if (!open) {
                          setJournalOptions((prev) => [...prev]);
                        }
                        setShowJournalOptions(open);
                      }}
                    >
                      <PopoverTrigger asChild>
                        <button
                          className={`flex items-center gap-1 px-3 py-1 h-[32px] rounded-md hover:bg-[#EFF1F1] ${
                            showJournalOptions ? "bg-[#D9D9D9]" : ""
                          }`}
                        >
                          <span className="text-[#35424D] text-[13px]">
                            <span className="font-semibold">Journal</span>{" "}
                            <span className="font-medium">
                              {getFilterLabel(
                                currentFilters.selectedJournals,
                                "",
                                JournalOptions
                              ).replace(/^Journal:\s*/, "")}
                            </span>
                          </span>
                          <i
                            className={`fas fa-chevron-down text-xs ${
                              showJournalOptions ? "rotate-180" : ""
                            }`}
                          />
                        </button>
                      </PopoverTrigger>
                      <DropdownCheckbox
                        options={
                          activeTab === "Article"
                            ? JournalOptions
                            : IssueJournalOptions
                        }
                        selectedValues={currentFilters.tempSelectedJournals}
                        onSelectionChange={handleJournalSelection}
                        selectAllText="All"
                        clearAllText="Clear all"
                        applyText="Apply"
                        type="Journal"
                        isOpen={showJournalOptions}
                        label={true}
                        searchPlaceholder="Search journals..."
                        onClose={() => setShowJournalOptions(false)}
                        SetSelectedValuesId={
                          activeTab === "Article"
                            ? (ids) =>
                                setArticleFilters((prev) => ({
                                  ...prev,
                                  tempSelectedJournals:
                                    ids.length >= 1 &&
                                    JournalOptions.length !== ids.length
                                      ? ids?.map((id) => id?.value)
                                      : ["All"],
                                  selectedJournalId:
                                    ids.length >= 1 &&
                                    JournalOptions.length !== ids.length
                                      ? ids
                                      : [],
                                }))
                            : (ids) =>
                                setIssueFilters((prev) => ({
                                  ...prev,
                                  tempSelectedJournals:
                                    ids.length >= 1 &&
                                    IssueJournalOptions.length !== ids.length
                                      ? ids?.map((id) => id?.value)
                                      : ["All"],
                                  selectedJournalId:
                                    ids.length >= 1 &&
                                    IssueJournalOptions.length !== ids.length
                                      ? ids
                                      : [],
                                }))
                        }
                      />
                    </Popover>
                    {activeTab === "Issue" && (
                      <Popover
                        open={showFilterPopover}
                        onOpenChange={(open) => {
                          setShowFilterPopover(open);
                          if (!open) {
                            // Reset nested popover states when main popover closes
                            setArticleTypeOpen(false);
                            setProductionWorkflowOpen(false);
                          }
                          if (open) {
                            if (activeTab === "Article") {
                              setArticleFilters((prev) => ({
                                ...prev,
                                tempArticleTypes: [...prev.articleTypes],
                                tempCopyediting: [...prev.copyediting],
                              }));
                            } else {
                              setIssueFilters((prev) => ({
                                ...prev,
                                tempTask: [...prev.task],
                              }));
                            }
                          }
                        }}
                      >
                        <PopoverTrigger asChild>
                          <button
                            className={`flex items-center justify-center p-2 w-[32px] h-[32px] hover:bg-[#E1E6FF] rounded-md
                        ${
                          showFilterPopover
                            ? "border-[#1C40C9] bg-[#B8C7FF] hover:bg-[#E1E6FF]"
                            : ""
                        }`}
                          >
                            <div className="relative">
                              <MdOutlineFilterAlt className="text-[#1C40C9] h-[15px] w-[15px]" />
                              {hasFilters && (
                                <span className="absolute top-[-2px] right-[-2px] h-[6px] w-[6px] bg-red-500 rounded-full" />
                              )}
                            </div>
                          </button>
                        </PopoverTrigger>
                        <DynamicFilterPopover
                          sections={sections}
                          tempSelected={tempSelected}
                          setTempSelected={setTempSelected}
                          clearAllFilters={handleAdvancedClearFilter}
                          applyFilters={applyFilters}
                          type={activeTab === "Article" ? "Article" : "Issue"}
                          articleTypeOpen={articleTypeOpen}
                          setArticleTypeOpen={setArticleTypeOpen}
                          productionWorkflowOpen={productionWorkflowOpen}
                          setProductionWorkflowOpen={setProductionWorkflowOpen}
                        />
                      </Popover>
                    )}
                  </div>
                </div>
                {currentFilters.searchQuery.length >= 3 && (
                  <p className="mt-1 mb-4 text-sm text-gray-600">
                    Showing search results:{" "}
                    <span className="text-black italic">
                      '{currentFilters.searchQuery}'
                    </span>
                  </p>
                )}
                {(currentFilters.searchQuery.trim() ||
                  !currentFilters.selectedVolIss.includes("All") ||
                  !currentFilters.selectedJournals.includes("All") ||
                  (activeTab === "Article" &&
                    (currentFilters.articleTypes.length > 0 ||
                      currentFilters.copyediting.length > 0)) ||
                  (activeTab === "Issue" &&
                    currentFilters.task.length > 0)) && (
                  <FilterChips
                    filters={{
                      searchTerm: currentFilters.searchQuery.trim()
                        ? currentFilters.searchQuery.trim()
                        : null,
                      selectedVolIss: currentFilters.selectedVolIss.includes(
                        "All"
                      )
                        ? null
                        : currentFilters.selectedVolIss,
                      selectedJournals:
                        currentFilters.selectedJournals.includes("All")
                          ? null
                          : currentFilters.selectedJournals,
                      selectedArticleTypes:
                        activeTab === "Article" &&
                        currentFilters.articleTypes.length > 0
                          ? currentFilters.articleTypes
                          : null,
                      selectedCopyediting:
                        activeTab === "Article" &&
                        currentFilters.copyediting.length > 0
                          ? currentFilters.copyediting
                          : null,
                      selectedTask:
                        activeTab === "Issue" && currentFilters.task.length > 0
                          ? currentFilters.task
                          : null,
                    }}
                    onRemoveFilter={(filterKey, value) => {
                      switch (filterKey) {
                        case "searchTerm":
                          if (activeTab === "Article") {
                            setArticleFilters((prev) => ({
                              ...prev,
                              searchQuery: "",
                            }));
                          } else {
                            setIssueFilters((prev) => ({
                              ...prev,
                              searchQuery: "",
                            }));
                          }
                          break;
                        case "selectedVolIss":
                          handleVolIssSelection(
                            currentFilters.selectedVolIss.filter(
                              (v) => v !== value
                            )
                          );
                          break;
                        case "selectedJournals":
                          handleJournalSelection(
                            currentFilters.selectedJournals.filter(
                              (j) => j !== value
                            ),
                            currentFilters.selectedJournalId.filter(
                              (j) => j.label !== value
                            )
                          );
                          break;
                        case "selectedArticleTypes":
                          if (activeTab === "Article") {
                            setArticleFilters((prev) => {
                              const updated = prev.articleTypes.filter(
                                (t) => t !== value
                              );
                              return {
                                ...prev,
                                articleTypes:
                                  updated.length > 0 ? updated : ["All"],
                                tempArticleTypes:
                                  updated.length > 0 ? updated : ["All"],
                              };
                            });
                          }
                          break;

                        case "selectedCopyediting":
                          if (activeTab === "Article") {
                            setArticleFilters((prev) => {
                              const updated = prev.copyediting.filter(
                                (c) => c !== value
                              );
                              return {
                                ...prev,
                                copyediting:
                                  updated.length > 0 ? updated : ["All"],
                                tempCopyediting:
                                  updated.length > 0 ? updated : ["All"],
                              };
                            });
                          }
                          break;

                        case "selectedTask":
                          if (activeTab === "Issue") {
                            setIssueFilters((prev) => ({
                              ...prev,
                              task: prev.task.filter((t) => t !== value),
                              tempTask: prev.tempTask.filter(
                                (t) => t !== value
                              ),
                            }));
                          }
                          break;
                        default:
                          break;
                      }
                      setCurrentPage(1);
                      setIssueCursor(null);
                    }}
                    onClearAll={handleClearFilters}
                  />
                )}
              </div>
              <div
                className={`content-section overflow-y-auto z-0 ${
                  !isNoTasks ? "border border-[#DCDCDC] rounded-md" : ""
                } `}
              >
                {isNoTasks &&
                isSearchEmpty &&
                !isLoadingArticles &&
                !isLoadingIssues ? (
                  <div className="flex flex-col items-center justify-center py-8">
                    <img
                      src={bookpng}
                      alt="No tasks"
                      className="w-[90px] h-[90px]"
                    />
                    <p className="text-[#35424D] font-semibold text-lg mb-4">
                      No historical tasks found
                    </p>
                    <p className="text-[#5D6871] text-sm mb-4">
                      There are no {activeTab.toLowerCase()} tasks in your
                      history
                    </p>
                    <button
                      className="text-[#1C40C9] hover:text-[#1C40C9] text-[13px] font-medium"
                      onClick={() => {
                        if (
                          userData.articleTaskManagement !== "None" &&
                          userData.issueTaskManagement !== "None"
                        ) {
                          navigate("/assignment");
                        }
                      }}
                    >
                      View my task assignment
                    </button>
                  </div>
                ) : isInitialLoading ||
                  (isLoadingArticles && !articles.length) ||
                  (isLoadingIssues && !issues.length) ? (
                  <div className="h-[50vh]">
                    <Spinner />
                  </div>
                ) : (
                  <div>
                    <CustomTable
                      data={activeTab === "Article" ? articles : issues}
                      searchTerm={currentFilters.searchQuery.trim()}
                      setSearchTerm={HandleClearSearch}
                      setLoading={
                        activeTab === "Article"
                          ? setIsLoadingArticles
                          : setIsLoadingIssues
                      }
                      headers={headers[activeTab]}
                      activeTab={activeTab}
                      sortConfig={sortConfig}
                      setSortConfig={setSortConfig}
                      setActiveRowId={setActiveRowId}
                      activeRowId={activeRowId}
                    />
                  </div>
                )}
              </div>
            </>
            {!isNoTasks && (
              <div className="sticky bottom-0 mt-auto bg-white z-10">
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  totalItems={totalItems}
                  itemsPerPage={itemsPerPage}
                  onPageChange={handlePageChange}
                  onItemsPerPageChange={(newItemsPerPage) => {
                    setItemsPerPage(newItemsPerPage);
                    setCurrentPage(1);
                    if (activeTab === "Issue" && currentPage === 1)
                      setIssueCursor(null);
                  }}
                  disablePrevious={
                    activeTab === "Issue" && !issueCursor && currentPage === 1
                  }
                  disableNext={activeTab === "Issue" && !issueCursor}
                />
              </div>
            )}
          </>
        )}
        {selectedTask && activeTab === "Issue" && openForm && (
          <div className="flex flex-col h-full">
            <IssueDetails
              text="My Tasks History (Issue)"
              formdata={selectedTask}
              onSave={handleUpdateTask}
              Onclose={handleCloseForm}
              fieldConfig={selectedFieldConfig}
              userOption={userOption}
              optionsMap={objectUserOption}
            />
          </div>
        )}
        {selectedTask && activeTab === "Article" && openForm && (
          <div className="flex flex-col h-full">
            <ArticleForm
              text="My Tasks History (Article)"
              initialData={selectedTask}
              onSave={handleUpdateTask}
              onCancel={handleCloseForm}
              onback={handleCloseForm}
              fieldConfiguration={selectedFieldConfig}
              productionHandlers={objectUserOption}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default MyHistoryTable;
